export default __webpack_public_path__ + "static/media/EmptyFolder.ddb5c94f.svg";